import { FC } from "react";
import { CountdownTimer } from "../../atoms";

import logoUppiness from "../../../assets/icons/logoUppiness.svg";

interface ISlotMachineHeader {
    isInDemoData?: boolean;
}


const SlotMachineHeader: FC<ISlotMachineHeader> = ({isInDemoData = false}) => {

    return (
        <div className="slot_machine_header_wrapper zIndex_for_slotmachine_header" style={{ width: "100vw" }}>
            <div className="component_header">

                <div className="" style={{ width: "30%" }}>
                    <img className="uppiness_logo" src={logoUppiness} alt="Uppiness Logo" />
                </div>

                <div style={{ width: "60%" }}>
                    
                </div>
                {!isInDemoData &&
                <div className="slot_machine_countdown_timer_wrapper" style={{ width: "30%" }}>
                    <CountdownTimer />
                </div>
                }
            </div>
        </div>
    )
}

export default SlotMachineHeader;